import { msg } from "@lingui/core/macro";
import { createRoute } from "@tanstack/solid-router";
import { appRoute } from "./route";
import { AuthPlaceholder } from "@/components/auth-placeholder";
import { PageContainer } from "@/components/ui/page-container";
import { ActivityFeedPage } from "@/features/activity/components/activity-feed-page";
import { useI18n } from "@/providers/i18n-provider";

function ActivityRoutePage() {
  const { t } = useI18n();
  return (
    <AuthPlaceholder
      title={t(msg`Activity`)}
      description={t(msg`Sign in to see who did what across your tasks and shared lists.`)}
    >
      <PageContainer maxWidth="3xl">
        <ActivityFeedPage />
      </PageContainer>
    </AuthPlaceholder>
  );
}

export const activityRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/activity",
  component: ActivityRoutePage,
});
